import type { TranslationInterface } from '.';

export const HindiLanguage: TranslationInterface = {
  write_a_message_placeholder: 'एक संदेश लिखें...',
  your_issue_has_been_resolved: 'आपकी समस्या हल हो गई है!',
  new_conversation: 'नई बातचीत',
  welcome_screen_title: 'हमारी सहायता चैट में आपका स्वागत है',
  welcome_screen_description:
    'हम मदद के लिए यहाँ हैं! बातचीत शुरू करें और हम जल्द से जल्द आपसे संपर्क करेंगे।',
  your_name_placeholder: 'आपका नाम',
  your_email_placeholder: 'आपका ईमेल पता',
  start_chat_button: 'सहायता से बात करें',
  start_chat_button_loading: 'कनेक्ट हो रहा है...',
  i_need_more_help: 'मुझे और मदद चाहिए',
  this_was_helpful: 'यह मददगार था',
  optional: 'वैकल्पिक',
  no_conversations_yet: 'अभी तक कोई बातचीत नहीं',
  back_to_conversations: 'बातचीत पर वापस जाएं',
  closed_conversations: 'बंद बातचीत',
  csat_title: 'आपकी बातचीत कैसी रही?',
  csat_submitted_title: 'आपने बातचीत को आंका',
  csat_feedback_placeholder: 'हमें और बताएं... (वैकल्पिक)',
  follow_up_placeholder: 'आगे पूछें…',
  companion_layout_label: 'लेआउट',
  companion_layout_floating: 'फ़्लोटिंग',
  companion_layout_sidebar: 'साइडबार',
  companion_layout_fullscreen: 'पूर्ण स्क्रीन',
  companion_close: 'बंद करें',
  companion_history: 'बातचीत का इतिहास',
  companion_expand_chat: 'चैट फैलाएँ',
  companion_sidebar_dock_label: 'डॉक',
  companion_sidebar_side_label: 'ओर',
  companion_sidebar_left: 'बाएँ',
  companion_sidebar_right: 'दाएँ',
  companion_resize_chat: 'चैट का आकार बदलें',
  scroll_to_bottom: 'नीचे स्क्रॉल करें',
  thinking: 'सोच रहा है…',
  running: 'चल रहा है…',
  steps: 'चरण',
  step_arguments: 'आर्ग्युमेंट',
  step_result: 'परिणाम',
  attach_files:
    'चित्र, वीडियो, PDF या स्प्रेडशीट संलग्न करें (अधिकतम आकार 25 MB)',
  mark_page_active:
    'चिह्नित करने के लिए पेज पर किसी भी चीज़ पर क्लिक करें — रद्द करने के लिए Esc दबाएँ',
  mark_page: 'पेज पर किसी चीज़ के बारे में पूछने के लिए उसे चिह्नित करें',
  stop_response: 'जवाब रोकें',
  copy_reply: 'उत्तर कॉपी करें',
  mentions_empty: 'कोई मेल नहीं',
  copied: 'कॉपी हो गया',
  send_message: 'संदेश भेजें',
  upload_failed: 'अपलोड विफल: {error}',
  remove_attachment: 'अटैचमेंट हटाएँ',
  json_no_items: 'कोई आइटम नहीं',
  json_no_data: 'कोई डेटा नहीं',
  json_no_chart_data: 'चार्ट के लिए कोई डेटा नहीं',
  json_unsupported: 'समर्थित नहीं: {type}',
  json_see_less: 'कम देखें',
  json_phone_agent: 'फ़ोन एजेंट',
  json_phone_agent_test: 'वेब से परखें',
  page_context_remove: 'पेज संदर्भ हटाएँ',
  json_see_more: '{count} और देखें',
  queued_label: '{count} कतार में',
  remove_queued_message: 'संदेश को कतार से हटाएँ',
  send_queued_now: 'कतार के संदेश अभी भेजें',
  turn_failed_message: 'कुछ गलत हुआ और जवाब नहीं आया।',
  turn_failed_retry: 'फिर से कोशिश करें',
  page_mark_hint: 'चिह्नित करने के लिए किसी भी चीज़ पर क्लिक करें',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'बॉक्स',
  page_mark_shape_circle: 'वृत्त',
  page_mark_shape_arrow: 'तीर',
  page_mark_shape_bracket: 'कोष्ठक',
  page_mark_shape_underline: 'रेखांकन',
  page_mark_shape_highlight: 'हाइलाइट',
  page_mark_shape_strike_through: 'काटने की रेखा',
  page_mark_shape_crossed_off: 'क्रॉस से काटें',
  page_mark_shape_aria: 'चिह्न का आकार: {shape}',
  page_mark_note_placeholder: 'नोट जोड़ें… (संलग्न करने के लिए Enter दबाएँ)',
  page_mark_attach: 'चिह्न संलग्न करें',
  page_mark_remove: '{label} हटाएँ',
  page_mark_region: 'चिह्नित क्षेत्र',
  page_mark_default_message: 'यह क्या है?',
  file_rejected: 'फ़ाइल प्रकार समर्थित नहीं है या फ़ाइल बहुत बड़ी है।',
  dictate: 'बोलकर लिखें',
  stop_dictation: 'डिक्टेशन रोकें',
  dictation_mic_blocked: 'बोलकर लिखने के लिए माइक्रोफ़ोन की अनुमति दें',
  dictation_unavailable: 'डिक्टेशन अभी उपलब्ध नहीं है',
  questions_back: 'पीछे',
  questions_next: 'आगे',
  questions_send: 'भेजें',
  questions_type_answer: 'मैं खुद लिखूंगा',
  questions_answer_placeholder: 'अपना उत्तर लिखें…',
  close_conversation_title: 'बातचीत बंद करें',
  close_conversation_description:
    'क्या आप वाकई इस बातचीत को बंद करना चाहते हैं?',
  close_conversation_cancel: 'नहीं',
  close_conversation_confirm: 'हाँ',
  dialog_close: 'बंद करें',
  zoom_in: 'ज़ूम इन',
  zoom_out: 'ज़ूम आउट',
  reset_zoom: 'ज़ूम रीसेट करें',
  support_chat_aria_label: 'सहायता चैट',
};
